import React from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'

interface OrderSubmissionLoadingProps {
  isOpen: boolean
  isRTL?: boolean
  message?: string
}

const OrderSubmissionLoading: React.FC<OrderSubmissionLoadingProps> = ({
  isOpen,
  isRTL = false,
  message
}) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  const displayMessage = message || t('order.processing') || 'جاري معالجة الطلب...'

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <div 
        className={`
          
           rounded-2xl p-8 max-w-sm w-full mx-4
          flex flex-col items-center justify-center gap-6
          transform transition-all duration-300
        `}
        style={{
          animation: 'fadeInScale 0.3s ease-out'
        }}
      >
        {/* Spinner Container */}
        <div className="relative">
          {/* Outer rotating ring */}
          <div className="absolute inset-0 border-1 border-flutter-button/10 rounded-full"></div>
          
          {/* Main spinner */}
          <div className="relative">
            <Loader2 
              className="w-16 h-16 text-flutter-button animate-spin" 
              strokeWidth={2.5}
            />
            
            {/* Inner pulse circle */}
            <div 
              className="absolute inset-0 rounded-full animate-ping"
              style={{
                backgroundColor: 'rgba(255, 107, 53, 0.2)',
                animation: 'ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite'
              }}
            ></div>
          </div>
        </div>

       

      
      </div>

   
    </div>
  )
}

export default OrderSubmissionLoading

